<template>
  <div class="not-found-container">
    <img src="../assets/misc/404.png" class="img-fluid not-found-image" alt="page not found" />

    <div class="togo-visual-elements">
      <router-link to="/home">
        <img class="to-go-image img-fluid" src="../assets/visual_menu/home.png" />
        <span class="togo-text">Home</span>
      </router-link>

      <router-link to="/achievements">
        <img class="to-go-image img-fluid" src="../assets/visual_menu/works.png" />
        <span class="togo-text">Achievements</span>
      </router-link>

      <router-link to="/tools">
        <img class="to-go-image img-fluid" src="../assets/visual_menu/tools.png" />
        <span class="togo-text">Tools</span>
      </router-link>

      <router-link to="/about">
        <img class="to-go-image img-fluid" src="../assets/visual_menu/about.png" />
        <span class="togo-text">About</span>
      </router-link>

      <router-link to="/contact">
        <img class="to-go-image img-fluid" src="../assets/visual_menu/contact.png" />
        <span class="togo-text">Contact</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style>
.not-found-container {
  margin-top: 100px;
  text-align: center;
}

.not-found-container .not-found-image {
  height: 150px;
}

.togo-visual-elements {
  margin-top: 50px;
}

.togo-visual-elements a {
  position: relative;
  opacity: 0.5;
  -webkit-opacity: 0.5;
  -o-opacity: 0.5;
  -moz-opacity: 0.5;
}

.togo-text {
  position: absolute;
  left: 0;
  right: 5px;
  bottom: -35px;
  color: rgb(170, 203, 236);
  font-weight: bold;
}

.to-go-image {
  margin: 20px;
  padding: 10px;
  height: 67px;
}

.togo-visual-elements a {
  padding: 20px;
  text-decoration: none;
}

.togo-visual-elements img:hover,
.togo-visual-elements a:hover {
  opacity: 1;
  -webkit-opacity: 1;
  -o-opacity: 1;
  -moz-opacity: 1;
}
</style>